import React from "react";
import { QuoteCard } from "modules/quote";
import { useHistory, useParams } from "react-router-dom";
import { PageContainer } from "components/shared/Page/PageContainer";

export const QuotePage = () => {
  const history = useHistory();
  const { VOId } = useParams<{ VOId: string }>();

  const handleGoToVO = () => {
    history.push(`/vo/${VOId}`);
  };

  return (
    <PageContainer>
      <QuoteCard onRedirect={handleGoToVO} voId={VOId} />
    </PageContainer>
  );
};
